import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/offer-pc-out.svg'
import _imports_1 from '@/assets/icons/offer-pc-in.svg'
import _imports_2 from '@/assets/icons/offer-money-out.svg'
import _imports_3 from '@/assets/icons/offer-money-in.svg'
import _imports_4 from '@/assets/icons/offer-call-out.svg'
import _imports_5 from '@/assets/icons/offer-call-in.svg'


const _hoisted_1 = { class: "section-offer" }
const _hoisted_2 = { class: "section-offer__container" }
const _hoisted_3 = { class: "offer-box" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "asset"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Tick",
  class: "tick"
}, null, -1)
const _hoisted_6 = { class: "offer-box" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "circle-arrow",
  alt: "asset"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "dollar",
  alt: "asset"
}, null, -1)
const _hoisted_9 = { class: "offer-box" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "day-night",
  alt: "asset"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "phone",
  alt: "asset"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiTile = _resolveComponent("UiTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.dict.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_UiTile, null, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.dict.safety), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_UiTile, null, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.dict.cancelation), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_UiTile, null, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.dict.availability), 1)
      ])
    ])
  ]))
}